module.exports = __webpack_public_path__ + "static/img/brees-2004-slide-1.ac3e9a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-slide-1.jpg
// module id = TfFn
// module chunks = 1